/** Khai niem chung cua capforge — dung o ca server, SDK va dashboard. */
/** Bon che do van hanh cua mot profile (muc 5 dac ta). */
export const PROFILE_MODES = ['off', 'shadow', 'canary', 'live'];
/** Nguon cua dap an cuoi cung tra ve cho client. */
export const SOLVE_SOURCES = ['local', 'upstream', 'canary-local'];
/** Trang thai vong doi cua mot Task. */
export const TASK_STATUSES = ['processing', 'ready', 'failed'];
/**
 * Nguon goc cua nhan mot mau (muc 10 dac ta).
 *
 * `traffic` khong nam trong dac ta goc nhung bat buoc phai co: mau thu tu request that
 * luc dau CHUA CO NHAN. Neu de mac dinh la "manual" thi sau nay khong con phan biet duoc
 * "nguoi da gan nhan tay" (dang tin) voi "chua ai dung toi" (chua dang tin) — dung mot gia
 * tri rieng ngay tu dau thi re, sua sau phai migrate du lieu.
 */
export const LABEL_SOURCES = [
    'traffic',
    'synthetic',
    'manual',
    'upstream',
    'model',
    'imported',
];
/** Scope cua API key. */
export const API_KEY_SCOPES = ['solve', 'admin'];
/**
 * Profile gia dinh cho captcha chua nhan dien duoc.
 * Moi mau roi vao day se hien o man hinh triage /admin/unknowns.
 */
export const UNKNOWN_PROFILE_KEY = '__unknown__';
/** Tien to cua API key tho. Key that co dang `cf_live_<32 hex>`. */
export const API_KEY_PREFIX = 'cf_live_';
//# sourceMappingURL=domain.js.map